(function () {
  const countryCurrencyMap = {
    AT: "EUR", BE: "EUR", BG: "BGN", HR: "EUR", CY: "EUR", CZ: "CZK", DK: "DKK", EE: "EUR", FI: "EUR", FR: "EUR", DE: "EUR", GR: "EUR", HU: "HUF", IE: "EUR", IT: "EUR", LV: "EUR", LT: "EUR", LU: "EUR", MT: "EUR", NL: "EUR", PL: "PLN", PT: "EUR", RO: "RON", SK: "EUR", SI: "EUR", ES: "EUR", SE: "SEK", GB: "GBP"
  };

  function formatMoney1(cents) {
    const select = document.querySelector("#country-drawer-selector-header");
    const country = select ? select.value : "IT";
    const currency = countryCurrencyMap[country] || "EUR";
    let locale = "en-IE";
    if (currency === "HUF") locale = "hu-HU";
    if (currency === "BGN") locale = "bg-BG";
    if (currency === "CZK") locale = "cs-CZ";
    if (currency === "DKK") locale = "da-DK";
    if (currency === "PLN") locale = "pl-PL";
    if (currency === "RON") locale = "ro-RO";
    if (currency === "SEK") locale = "sv-SE";
    if (currency === "GBP") locale = "en-GB";
    return (cents / 100).toLocaleString(locale, {
      style: "currency",
      currency: currency,
    });
  }

  function renderRelatedProducts() {
    const container = document.querySelector("#related-cart-products");
    if (!container) return;
    const productId = container.getAttribute("data-product-id");
    if (!productId) return;
    const relatedTitle = container.getAttribute("data-translation") || "";
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}recommendations/products.json?product_id=${productId}&limit=4`)
      .then(response => response.json())
      .then(data => {
        if (!data.products.length) return;
        let html = `<h3 class="related-title">${relatedTitle}</h3><div class="related-grid">`;
        data.products.forEach(product => {
          html += `
            <div class="related-item">
              <a href="${product.url}">
                <img src="${product.featured_image}" alt="${product.title}" />
                <div class="related_info">
                  <p class="card_title">${product.title}</p>
                  <p class="card_price">${formatMoney1(product.price)}</p>
                </div>
              </a>
              <button class="related-add-btn" data-variant-id="${product.variants[0].id}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(255,255,255,1)"><path d="M13.0001 10.9999L22.0002 10.9997L22.0002 12.9997L13.0001 12.9999L13.0001 21.9998L11.0001 21.9998L11.0001 12.9999L2.00004 13.0001L2 11.0001L11.0001 10.9999L11 2.00025L13 2.00024L13.0001 10.9999Z"></path></svg>
              </button>
            </div>
          `;
        });
        html += `</div>`;
        container.innerHTML = html;
        const itemLength = document.querySelectorAll('cart-drawer-items .cart-drawer__items .cart-item')?.length || 0;
        localStorage.setItem('cartQty', itemLength);
      })
      .catch(err => console.error('cart-upsell render error', err));
  }

  window.__relatedProductsRender = renderRelatedProducts;

  function waitForElement(selector) {
    return new Promise(resolve => {
      const existing = document.querySelector(selector);
      if (existing) return resolve(existing);
      const observer = new MutationObserver(() => {
        const elem = document.querySelector(selector);
        if (elem) {
          observer.disconnect();
          resolve(elem);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  function init() {
    renderRelatedProducts();

    document.addEventListener("click", function (e) {
      const btn = e.target.closest(".related-add-btn");
      if (!btn || btn.disabled) return;

      btn.disabled = true;
      const relatedItem = btn.closest(".related-item");
      const variantId = btn.getAttribute("data-variant-id");

      if (relatedItem) {
        relatedItem.style.opacity = "0.4";
        relatedItem.style.pointerEvents = "none";
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: ['cart-drawer'] })
      })
        .then(res => res.json())
        .then(addResponse => {
          const sectionHTML = addResponse.sections && addResponse.sections['cart-drawer'];
          if (sectionHTML) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionHTML, "text/html");

            const newItems = doc.querySelector(".cart-drawer__items");
            const currentItems = document.querySelector(".cart-drawer__items");
            if (newItems && currentItems) {
              currentItems.innerHTML = newItems.innerHTML;
            }

            const newSummary = doc.querySelector("#cart-summary");
            const currentSummary = document.querySelector("#cart-summary");
            if (newSummary && currentSummary) {
              currentSummary.innerHTML = newSummary.innerHTML;
            }
          }
          return fetch("/cart.js");
        })
        .then(r => r.json())
        .then(cart => {
          if (relatedItem) relatedItem.remove();
          if (cart.items.length) {
            const last = cart.items[cart.items.length - 1];
            document
              .querySelector("#related-cart-products")
              ?.setAttribute("data-product-id", last.product_id);
          }
          renderRelatedProducts();
        })
        .catch(err => {
          console.error(err);
          btn.disabled = false;
          if (relatedItem) {
            relatedItem.style.opacity = "";
            relatedItem.style.pointerEvents = "";
          }
        });
    });

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        localStorage.setItem('cartQty', cart.item_count);
      });

    document.addEventListener("click", function (e) {
      const checkClass = document.querySelector('cart-drawer');
      if (checkClass && !checkClass.classList.contains('is-visible')) {
        document.body.style.overflow = 'unset';
      }
      const btn = e.target.closest(".card-product__sizes-btn, .quick-add-btn, .product-form__submit");
      if (!btn) return;
      waitForElement('cart-drawer-items .cart-drawer__items .cart-item').then(() => {
        const checkItemLength = setInterval(function () {
          const savedQty = localStorage.getItem('cartQty');
          const itemLength = document.querySelectorAll('cart-drawer-items .cart-drawer__items .cart-item')?.length;
          if (savedQty != itemLength) {
            clearInterval(checkItemLength);
            renderRelatedProducts();
          }
        }, 100);
      });
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const reRenderObserver = new MutationObserver(() => {
        const container = document.querySelector('#related-cart-products');
        if (!container) return;
        if (container.children.length === 0 && container.getAttribute('data-product-id')) {
          renderRelatedProducts();
        }
      });
      reRenderObserver.observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
